import React, { useEffect, useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
import styled from "styled-components";

import { Pagination, Spin, Table } from "antd";
import { handleError } from "../../../modules/presence/sagas";
import { Select } from "antd";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;
`;

const baseapi = process.env.REACT_APP_API + "/api";
const PAGE_SIZE = 20;
const Filter = ({ item, selectedItem, fetchDistinct, onChange, placeholder, token, width }) => {
  const [items, setItems] = useState([]);

  return (
    <Select
      allowClear={true}
      showSearch
      placeholder={placeholder}
      style={{ width: width || 200, margin: 5 }}
      value={selectedItem}
      onFocus={async () => {
        const response = await fetchDistinct(item, token);
        setItems(response);
      }}
      onChange={onChange}
    >
      {items.map(client => (
        <Select.Option key={client} value={client}>
          {client}
        </Select.Option>
      ))}
    </Select>
  );
};

const LuccaAttendances = ({ token }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [user, setUser] = useState();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();

  const fetchLuccaAttendances = async () => {
    setIsLoading(true);
    try {
      const result = await axios.post(
        `${baseapi}/lucca`,
        {
          match: { user_email: user },
          sort: { date: -1 },
          page,
          pageSize: PAGE_SIZE
        },
        {
          headers: {
            Authorization: token
          }
        }
      );
      setData(result.data.docs);

      setTotal(result.data.total / 2);
    } catch (e) {
      handleError(e);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    fetchLuccaAttendances();
  }, [page, user]);
  const columns = [
    {
      title: "user",
      dataIndex: "user_email",
      key: "user_email",
      render: user_email => {
        return <span>{user_email}</span>;
      }
    },
    {
      title: "lucca_id",
      dataIndex: "user_lucca_id",
      key: "user_lucca_id",
      render: user_lucca_id => {
        return <span>{user_lucca_id}</span>;
      }
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date, record) => {
        return <span> {dayjs(date).format("DD-MM-YYYY")}</span>;
      }
    },

    {
      title: "Vacances ? ",
      dataIndex: "isHoliday",
      key: "isHoliday",
      render: isHoliday => {
        return <span>{isHoliday ? "Oui" : "Non"}</span>;
      }
    },
    {
      title: "Jour travaillé ? ",
      dataIndex: "isWorkingDay",
      key: "isWorkingDay",
      render: isWorkingDay => {
        return <span>{isWorkingDay ? "Oui" : "Non"}</span>;
      }
    }
  ];
  return (
    <Container>
      <HeaderContainer>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          <div style={{ fontSize: 30, width: "30%" }}>{`Liste présences importées de Lucca`}</div>
        </div>
        <div style={{ width: "30%" }} />
        <Filter
          fetchDistinct={fetchDistinct}
          item={"user_email"}
          placeholder={"email"}
          token={token}
          onChange={value => setUser(value)}
          width={400}
        />
      </HeaderContainer>
      <React.Fragment>
        {isLoading ? (
          <Spin />
        ) : (
          <Table rowKey="_id" columns={columns} dataSource={data} pagination={false} align="center" />
        )}
        <Pagination defaultCurrent={1} total={total} onChange={setPage} />
      </React.Fragment>
    </Container>
  );
};

export default LuccaAttendances;

const fetchDistinct = async (item, token, filters = { match: {} }) => {
  return axios
    .post(`${baseapi}/lucca/distincts/${item}`, filters, {
      headers: {
        Authorization: token
      }
    })
    .then((response = {}) => {
      return response.data;
    })
    .catch(e => {
      console.log(e);
      return [];
    });
};



// WEBPACK FOOTER //
// src/pages/devs/lucca_attendances/LuccaAttendances.js